// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideX as RawLucideX } from "lucide-react";
export const LucideX = /* @__PURE__ */ createIcon(RawLucideX, "LucideX", 2);
